module.exports = __webpack_public_path__ + "img/phone-16.a810669c.svg";